export function validateUrl(url) {
	const regex = /^https?:\/\/.+/;
	return regex.test(String(url));
}

export function validateUrlXXX(url) {
	const regex = /xxx/i;
	return regex.test(String(url));
}
